(function () {
  'use strict';

  /* 1) Form con data-smart-cart-form (pagina carrello): checkout bloccato sotto il minimo. */
  function blockInvalidCheckout(event) {
    var form = event.target && event.target.closest ? event.target.closest('[data-smart-cart-form]') : null;
    if (!form) return;

    var blockedButton = form.querySelector('[data-smart-checkout-blocked]');
    if (!blockedButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    blockedButton.focus({ preventScroll: false });
  }

  /* 2) Carrello a scomparsa (form#mini-cart): sotto il minimo d'ordine il pulsante e' un
        invito (data-smart-checkout-nudge, type="button"). Finche' e' presente, nessun invio
        del form arriva al checkout (es. tasto Invio in un campo quantita'). */
  function blockDrawerCheckout(event) {
    var form = event.target;
    if (!form || form.id !== 'mini-cart' || !form.querySelector) return;
    if (!form.querySelector('[data-smart-checkout-nudge]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  document.addEventListener('submit', blockInvalidCheckout, true);
  document.addEventListener('submit', blockDrawerCheckout, true);
  document.addEventListener('click', function (event) {
    var checkout = event.target && event.target.closest ? event.target.closest('[data-smart-checkout-blocked]') : null;
    if (!checkout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  /* 3) Click sul pulsante-invito: scorre l'area del carrello fino ai consigli
        ([data-smart-cart-nudge-target]) e li evidenzia per 1,2 s.
        Se non ci sono consigli, torna in cima al box spedizione. */
  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function scrollParent(element, stopAt) {
    var node = element.parentElement;
    while (node && node !== stopAt && node !== document.body) {
      var style = window.getComputedStyle(node);
      if (/(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight + 1) return node;
      node = node.parentElement;
    }
    return null;
  }

  function highlight(target) {
    target.classList.remove('sa-nudge-pulse');
    void target.offsetWidth;
    target.classList.add('sa-nudge-pulse');
    window.clearTimeout(target.saNudgeTimer);
    target.saNudgeTimer = window.setTimeout(function () {
      target.classList.remove('sa-nudge-pulse');
    }, 1300);
  }

  document.addEventListener('click', function (event) {
    var nudge = event.target && event.target.closest ? event.target.closest('[data-smart-checkout-nudge]') : null;
    if (!nudge) return;
    event.preventDefault();

    var root = nudge.closest('#mini-cart') || document;
    var target = root.querySelector('[data-smart-cart-nudge-target]');
    var toTop = !target;
    if (toTop) target = root.querySelector('[data-smart-cart-progress]') || root.querySelector('.sa-cart-top');
    if (!target) return;

    var behavior = reducedMotion() ? 'auto' : 'smooth';
    var scroller = scrollParent(target, root === document ? null : root.parentNode);

    if (scroller) {
      var top = 0;
      if (!toTop) {
        var sticky = scroller.querySelector('.sa-cart-top');
        var stickyHeight = sticky ? sticky.offsetHeight : 0;
        top = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - stickyHeight - 8;
      }
      top = Math.max(0, top);
      try {
        scroller.scrollTo({ top: top, behavior: behavior });
      } catch (error) {
        scroller.scrollTop = top;
      }
    } else if (target.scrollIntoView) {
      try {
        target.scrollIntoView({ behavior: behavior, block: 'nearest' });
      } catch (error) {
        target.scrollIntoView(false);
      }
    }

    highlight(target);
  });

  /* 4) Scroll touch nel carrello a scomparsa (mobile) - round 9, un solo meccanismo.
        Un listener touchmove su window in fase di CAPTURE: per i tocchi dentro l'area che
        scorre (#mini-cart .mini-cart__content) ferma la propagazione, cosi' nessun altro
        handler touchmove della pagina li vede (blocco scroll del tema sul document, eventuali
        resti del vecchio carosello upsell). Non chiama mai preventDefault: lo scroll nativo resta.
        Se il contenuto non e' piu' alto dell'area (niente da scorrere) non interviene, cosi' il
        blocco del tema impedisce alla pagina dietro il cassetto di scorrere.
        Sta su window: sopravvive ai re-render del carrello senza ricollegamenti.
        touchstart (stesso modo, senza fermare la propagazione: i pulsanti ne hanno bisogno):
        tiene lo scroll a 1 px dai bordi, per i vecchi iOS che ignorano overscroll-behavior. */
  var SCROLL_AREA_SELECTOR = '#mini-cart .mini-cart__content';

  function scrollAreaFor(target) {
    return target && target.closest ? target.closest(SCROLL_AREA_SELECTOR) : null;
  }

  function maxScroll(area) {
    return area.scrollHeight - area.clientHeight;
  }

  window.addEventListener('touchmove', function (event) {
    var area = scrollAreaFor(event.target);
    if (!area || maxScroll(area) <= 1) return;
    event.stopPropagation();
  }, { capture: true, passive: true });

  window.addEventListener('touchstart', function (event) {
    var area = scrollAreaFor(event.target);
    if (!area) return;
    var max = maxScroll(area);
    if (max <= 1) return;
    if (area.scrollTop <= 0) area.scrollTop = 1;
    else if (area.scrollTop >= max) area.scrollTop = max - 1;
  }, { capture: true, passive: true });
})();
